export const SET_RADIO_BUTTON_VALUE = 'SET_RADIO_BUTTON_VALUE';
export const CONVERT_FROM_CSV_FOR_CONTRACTING = 'CONVERT_FROM_CSV_FOR_CONTRACTING';
export const SEARCH_LIST_ITEMS = 'SEARCH_LIST_ITEMS';
export const ADD_SELECTED_CONNECTIONS = 'ADD_SELECTED_CONNECTIONS';
export const CHANGE_ADD_FOLDER_DIALOG_STATE = 'CHANGE_ADD_FOLDER_DIALOG_STATE';
export const MODAL_ACTIONS = 'MODAL_ACTIONS';
export const ADD_CONTRACT_SETTINGS_UPDATE = 'ADD_CONTRACT_SETTINGS_UPDATE';
export const SET_SUBMISSION_CRITERIA_COPY_TEMPLATE_DROPDOWN_VALUE = 'SET_SUBMISSION_CRITERIA_COPY_TEMPLATE_DROPDOWN_VALUE';

export const wizardMappedActions = {
  addContractSettingsUpdate: 'ADD_CONTRACT_SETTINGS_UPDATE',
  disableContinueAndShowErrors: 'DISABLE_CONTINUE_AND_SHOW_ERRORS',
  showAllContractPartners: 'SHOW_ALL_CONTRACT_PARTNERS',
  notesRadioButtonChange: 'NOTES_RADIO_BUTTON_CHANGE',
  termsRadioButtonChange: 'TERMS_RADIO_BUTTON_CHANGE',
};



// WEBPACK FOOTER //
// ./src/app/stores/contracting/wizard/wizard-constants.js